import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { usePlatform } from './usePlatform';
import { CompanyAdminRoutes } from '@/types/enums/RouteNameEnums';

/**
 * Composable for registering global keyboard shortcuts
 *
 * Currently supported shortcuts:
 * - Cmd+K (macOS) / Ctrl+K (Windows/Linux): Navigate to AI Chat page
 *
 * @example
 * // In App.vue or main layout component
 * import { useGlobalShortcuts } from '@/composables'
 * useGlobalShortcuts()
 */
export function useGlobalShortcuts(): void {
    const router = useRouter();
    const { isMac } = usePlatform();

    /**
     * Handles keyboard events for global shortcuts
     *
     * @param {KeyboardEvent} event - The keyboard event
     */
    const handleKeydown = (event: KeyboardEvent): void => {
        // Cmd+K (macOS) or Ctrl+K (other platforms) - Navigate to AI Chat
        const isModifierPressed = isMac.value ? event.metaKey : event.ctrlKey;
        const isKKey = event.key.toLowerCase() === 'k';

        if (isModifierPressed && isKKey) {
            event.preventDefault();
            router.push({ name: CompanyAdminRoutes.AiChat });
        }
    };

    onMounted(() => {
        window.addEventListener('keydown', handleKeydown);
    });

    onUnmounted(() => {
        window.removeEventListener('keydown', handleKeydown);
    });
}
